var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86448 15.9517H4.52543V17.7284C4.52543 17.9735 4.73986 18.188 4.98493 18.188H7.40498C7.65004 18.188 7.86448 17.9735 7.86448 17.7284V15.9517Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4746 15.9517H16.1355V17.7284C16.1355 17.9735 16.35 18.188 16.595 18.188H19.0151C19.2601 18.188 19.4746 17.9735 19.4746 17.7284V15.9517Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54724 14.42C7.03787 14.42 7.43561 14.0223 7.43561 13.5317C7.43561 13.041 7.03787 12.6433 6.54724 12.6433C6.0566 12.6433 5.65887 13.041 5.65887 13.5317C5.65887 14.0223 6.0566 14.42 6.54724 14.42Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3609 14.42C17.8515 14.42 18.2492 14.0223 18.2492 13.5317C18.2492 13.041 17.8515 12.6433 17.3609 12.6433C16.8702 12.6433 16.4725 13.041 16.4725 13.5317C16.4725 14.0223 16.8702 14.42 17.3609 14.42Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18845 11.418V15.6454C4.18845 15.8292 4.31099 15.9517 4.49479 15.9517H19.5052C19.689 15.9517 19.8115 15.8292 19.8115 15.6454V11.418L18.433 10.0088L17.269 6.45533C17.1464 6.08773 16.8095 5.81203 16.4112 5.81203H7.6194C7.22117 5.81203 6.8842 6.05709 6.73103 6.45533L5.56696 10.0088L4.18845 11.418Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56696 10.0088H18.433",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8115 11.418H4.18845",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0042 8.69157H19.689C19.9034 8.69157 20.026 8.87537 19.9953 9.08981L19.7503 10.0088H18.4637",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99584 8.69157H4.31099C4.09656 8.69157 3.97402 8.87537 4.00466 9.08981L4.24973 10.0088H5.53633",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.39892493b2675dff54ad53f628b9b138.svg";
export { ForwardRef as ReactComponent };